import { render, staticRenderFns } from "./Sharepoint.vue?vue&type=template&id=996f69e4&scoped=true&"
import script from "./Sharepoint.vue?vue&type=script&lang=js&"
export * from "./Sharepoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996f69e4",
  null
  
)

export default component.exports